import React, { useState, useEffect } from 'react';

const DeleteConfirmation = ({
  onConfirm,
  onCancel,
  isDeleting = false,
  registrationName = '',
  toEmails = [],
  ccEmails = [],
  isLoadingEmails = false,
}) => {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [displayToEmails, setDisplayToEmails] = useState([]);
  const [displayCcEmails, setDisplayCcEmails] = useState([]);

  // Update email display based on loading state
  useEffect(() => {
    if (isLoadingEmails) {
      setDisplayToEmails([]);
    } else {
      setDisplayToEmails(toEmails || []);
    }
  }, [isLoadingEmails, toEmails]);

  useEffect(() => {
    if (isLoadingEmails) {
      setDisplayCcEmails([]);
    } else {
      setDisplayCcEmails(ccEmails || []);
    }
  }, [isLoadingEmails, ccEmails]);

  const handleSend = () => {
    onConfirm({ subject, message });
  };

  const isDisabled = !subject.trim() || !message.trim() || isDeleting || isLoadingEmails;

  const EmailPillField = ({ label, isLoading, emails }) => {
    return (
      <div className="mb-4">
        <div className="flex items-start gap-2">
          <span className="text-gray-700 font-medium text-sm mt-1.5">{label}</span>
          <div className="flex flex-wrap gap-2">
            {isLoading ? (
              <div className="flex items-center bg-gray-200 rounded-full px-4 py-2 animate-pulse">
                <div className="h-3 bg-gray-300 rounded w-32"></div>
              </div>
            ) : (
              emails &&
              emails.length > 0 &&
              emails.map((email, index) => (
                <span
                  key={index}
                  className="inline-flex items-center bg-blue-100 text-blue-800 text-sm font-medium px-3 py-1.5 rounded-full">
                  {email}
                </span>
              ))
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="w-full flex flex-col space-y-4">
      <div className="bg-blue-50 rounded-xl overflow-hidden">
        <div className="p-4">
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">Sujet :</label>
            <input
              type="text"
              className="w-full p-3 border rounded-md bg-white text-sm placeholder:text-sm"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              disabled={isDeleting || isLoadingEmails}
              placeholder="Insérer un sujet"
            />
          </div>

          <EmailPillField label="Pour :" isLoading={isLoadingEmails} emails={displayToEmails} />

          {(isLoadingEmails || (displayCcEmails && displayCcEmails.length > 0)) && (
            <EmailPillField label="CC :" isLoading={isLoadingEmails} emails={displayCcEmails} />
          )}

          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">Insérer un message</label>
            <textarea
              placeholder="Insérer un message"
              className="w-full p-4 min-h-[120px] border rounded-md bg-white resize-none text-sm placeholder:text-sm"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              disabled={isDeleting || isLoadingEmails}
            />
          </div>
        </div>
      </div>
      <div className="p-3 mb-4">
        <p className="text-red-600 text-sm">
          <span className="font-semibold">Attention :</span> Cette action supprimera définitivement
          toutes les données. Cette opération est irréversible.
        </p>
      </div>

      <div className="flex justify-end gap-3">
        <button
          onClick={onCancel}
          disabled={isDeleting}
          className="px-6 py-2 border border-gray-300 text-gray-700 hover:bg-gray-300 hover:scale-105 active:scale-95 transition-all duration-300 rounded-lg font-medium disabled:opacity-50 disabled:cursor-not-allowed">
          ANNULER
        </button>
        <button
          onClick={handleSend}
          disabled={isDisabled}
          className={`${
            isDisabled
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-red-10 hover:bg-red-20 hover:scale-105 active:scale-95'
          } text-white transition-all duration-300 px-6 py-2 rounded-lg flex items-center gap-2 font-medium`}>
          {isDeleting ? (
            <>
              <svg
                className="animate-spin h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24">
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span>Envoi en cours...</span>
            </>
          ) : (
            <span>SUPPRIMER ET ENVOYER</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default DeleteConfirmation;
